const topicsData = [
  { label: '韩漫推荐', count: '2.3万讨论' },
  { label: '日漫经典', count: '1.8万讨论' },
  { label: '国漫崛起', count: '1.5万讨论' },
  { label: '玄幻漫画', count: '9800讨论' },
  { label: '恋爱漫画', count: '1.2万讨论' },
  { label: '热血漫画', count: '9600讨论' },
  { label: '漫画排行', count: '8500讨论' },
  { label: '新番速递', count: '7200讨论' },
  { label: '漫画推荐', count: '6800讨论' },
  { label: '悬疑漫画', count: '5400讨论' },
  { label: '搞笑漫画', count: '5100讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在讨论的漫画话题，快来加入</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full transition-all duration-200 no-underline ${
                i < 3
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-60 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}